import { gql } from "@apollo/client";
import { TRIVIA_ANSWER_OPTION_FIELDS } from "../fragments";

export const TRIVIA_ANSWER_OPTION_UPDATE = gql`
  ${TRIVIA_ANSWER_OPTION_FIELDS}
  mutation TriviaAnswerOptionUpdate($triviaAnswerOptionId: String!, $data: TriviaAnswerOptionUpdateInput!) {
    triviaAnswerOptionUpdate(triviaAnswerOptionId: $triviaAnswerOptionId, data: $data) {
      ...TriviaAnswerOptionFields
    }
  }
`;
